import { Component, Inject, OnInit } from "@angular/core";
import { Calculation, Client } from "@salaxy/core";
import { ClientNg, Token } from "../../../services/index";

/** Simple calculations listing implementation demo. */
@Component({
    selector: "sxdemo-calc-list-simple",
    template: `<h1>Calculation list - simple</h1>
<p>
This calculation list component fetches the data directly using the API methods.
The data is fetched every time the component loads: Obeserve "Fetching calcs" in the debug console.
</p>
<div class="salaxy-row">
    <div class="scol-4">
        <mat-list>
            <h3 md-subheader>Salary calculations (click to show on the right)</h3>
            <mat-list-item *ngFor="let calc of calculations" (click)="setCurrentId(calc.id)" class="click">
                <mat-icon md-list-avatar>euro_symbol</mat-icon>
                <h4 md-line>{{calc.result.totals.totalGrossSalary | currency : 'EUR' : true }} at {{calc.paidAt | date}}</h4>
                <p md-line>{{calc.employer.avatar.displayName || "?" }} => {{calc.worker.avatar.displayName || "?"}}</p>
                <p md-line>{{calc.id}}</p>
            </mat-list-item>
        </mat-list>
    </div>
    <div class="scol-8">
        <pre>{{ current | json }}</pre>
    </div>
</div>
`,
})
export class NgCalcListSimpleComponent implements OnInit {

    /** List of calculations */
    public calculations: Calculation[] = [];

    /** Currently selected calculation */
    public current: Calculation = {} as any;

    /**
     * Default constructor creates a new CalcListComponent
     * @param calcApi - Raw API for the method
     * @param sessionService - Service to check whether the use s authenticated.
     */
    constructor(
        @Inject(ClientNg) private client: Client,
        private token: Token,
    ) { }

    /**
     * Starts loading calculations for the user if there is a currentToken,
     * typically stored in the cookie.
     */
    public ngOnInit() {
        if (this.token && this.token.currentToken) {
            this.client.calculationsApi.getAll().then ( (calcs) => {
                this.calculations = calcs ;
            });
        }
    }

    /**
     * Sets the current calculation - starts loading from the server
     * @param id - Identifier of the calculation
     */
    public setCurrentId(id: string) {
        this.client.calculationsApi.get(id).then((calc) => this.current = calc);
    }
}
